import { render, staticRenderFns } from "./AttachModalUpload.vue?vue&type=template&id=1f824969&scoped=true"
import script from "./AttachModalUpload.vue?vue&type=script&lang=js"
export * from "./AttachModalUpload.vue?vue&type=script&lang=js"
import style0 from "./AttachModalUpload.vue?vue&type=style&index=0&id=1f824969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f824969",
  null
  
)

export default component.exports